import React, { Component } from 'react';
import Cards from './Cards';
import './Cards.css';
import FormBuilderContainer from './FormBuilderContainer';
import { createTheme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import DropDown from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import CoverImage from './CoverImage';
import { PlaylistAddCheckRounded, DirectionsRounded, OpenInNew } from '@mui/icons-material';
import Toolbar from '@mui/material/Toolbar';
import { Grid } from '@mui/material';
import CustomPaper from '../common/CustomPaper';
import AddFieldButton from './AddFieldButton/AddFieldButton';
import FormFieldWrapper from './FormFieldWrapper/FormFieldWrapper';
import { CopyToFormDialog } from './FormDialogs/CopyToFormDialog';

import update from 'immutability-helper';

const styles = theme => ({
  textroot: {
    width: '100%',
    height: '100px',
    margin: 'auto',
  },
  pagetitle: {
    fontWeight: 300,
    fontSize: '3.3rem',
  },
  pageDescription: {
    fontSize: '1rem',
  },
  textField: {
    width: 600,
    margin: 'auto',
    position: 'relative',
  },
});
class Validation extends Component {
  state = {
    pageTitle: '',
    pageDescription: '',
    copyToFormDialogOpen: false,
    copyToFormQuestionId: null,
  };
  handleInput = (type, event) => {
    FormBuilderContainer.pageTitles[0][type] = event.target.value;
    this.forceUpdate();
  };

  deleteItem = id => {
    FormBuilderContainer.pages = FormBuilderContainer.pages.filter(item => item.id !== id);
    FormBuilderContainer.notify();
    this.forceUpdate();
  };

  moveCard = (dragIndex, hoverIndex) => {
    let newcards = FormBuilderContainer.pages;

    let dragCard = newcards[dragIndex];

    newcards.splice(dragIndex, 1);

    newcards.splice(hoverIndex, 0, dragCard);

    FormBuilderContainer.pages = newcards;
    this.forceUpdate();
  };

  moveArrayItemToNewIndex = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  upItem = id => {
    const cards = [...FormBuilderContainer.pages];
    let index = cards.findIndex(card => card.id == id);
    let result = this.moveArrayItemToNewIndex(cards, index, index - 1);
    FormBuilderContainer.pages = result;
    this.forceUpdate();
  };

  downItem = id => {
    const cards = [...FormBuilderContainer.pages];
    let index = cards.findIndex(card => card.id == id);
    let result = this.moveArrayItemToNewIndex(cards, index, index + 1);
    FormBuilderContainer.pages = result;
    this.forceUpdate();
  };

  editItem = id => {
    FormBuilderContainer.editComponent(id);
    FormBuilderContainer.onEdit = true;
    FormBuilderContainer.notify();
  };
  copyItem = id => {
    FormBuilderContainer.copyItem(id);
    FormBuilderContainer.notify();
    this.forceUpdate();
  };

  copyToForm = id => {
    this.setState({
      copyToFormDialogOpen: true,
      copyToFormQuestionId: id,
    });
  };

  handleCloseCopyToFormDialog = () => {
    this.setState({
      copyToFormDialogOpen: false,
      copyToFormQuestionId: null,
    });
  };

  handleFieldSelect = (fieldType, position) => {
    if (position !== undefined && position >= 0) {
      FormBuilderContainer.setComponentAndPosition(fieldType, position);
    } else {
      FormBuilderContainer.addComponent(fieldType);
    }
    if (this.props.setInnerPlaceholders) {
      this.props.setInnerPlaceholders();
    }
    FormBuilderContainer.notify();
    this.forceUpdate();
  };

  render() {
    const theme = createTheme({
      palette: {
        primary: { 500: '#000000' },
      },
      typography: { useNextVariants: true },
    });
    const data = FormBuilderContainer.pageTitles;
    const {
      classes,
      coverImage,
      coverImageCrop,
      linkedComponent,
      redirectToExternalUrl,
      redirectUrl,
      launchSettingDialog,
      uploadIcon,
      formTitle,
    } = this.props;

    return (
      <>
        <CustomPaper
          sx={{
            minHeight: '65vh',
            maxWidth: '100%',
            padding: 0, // Override default padding since we have Toolbar and internal padding
          }}
        >
          <Toolbar
            variant="dense"
            style={{ minHeight: '45px !important', borderBottom: '1px solid var(--mui-palette-divider)' }}
            xs={12}
          >
            <Grid container direction="row" alignItems="center">
              <Grid item>
                <Grid container direction="row" alignItems="center" justify="flex-start">
                  <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                    <Grid style={{ width: 'auto', height: '32px' }}>
                      <img
                        alt="logo"
                        style={{
                          width: 'auto',
                          height: '100%',
                          borderRadius: 8,
                        }}
                        src={uploadIcon || '/images/default-image-form.png'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}>
                {formTitle}
              </Grid>
            </Grid>
          </Toolbar>

          {coverImage !== undefined && coverImage !== '' ? (
            <div className="form-cover-image">
              <CoverImage coverImage={coverImage} coverImageCrop={coverImageCrop} />
            </div>
          ) : (
            ''
          )}

          <div className="appIntro">
            <div style={{ textAlign: 'center' }} className="cardContainer">
              {FormBuilderContainer.pages.length == 0 && (
                <div>
                  <p style={{ marginTop: '20vh', color: 'var(--mui-palette-text-secondary)' }}>
                    Start building your form by adding fields
                  </p>
                  <AddFieldButton onFieldSelect={this.handleFieldSelect} isEmptyState={true} />
                </div>
              )}
              {FormBuilderContainer.pages.map((card, i) => {
                if (i == 0) {
                  return (
                    <div key={`card-container-${i}`}>
                      <div className="cardPageTitle">
                        <TextField
                          value={data[0].page_title}
                          variant="standard"
                          fullWidth
                          InputProps={{ 
                            disableUnderline: true,
                            sx: { fontSize: 16, fontWeight: 500, color: 'text.secondary' }
                          }}
                          onChange={this.handleInput.bind(this, 'page_title')}
                        />
                      </div>
                      <FormFieldWrapper
                        card={card}
                        index={i}
                        editItem={this.editItem}
                        copyItem={this.copyItem}
                        copyToForm={this.copyToForm}
                        deleteItem={this.deleteItem}
                        moveCard={this.moveCard}
                        upItem={this.upItem}
                        downItem={this.downItem}
                        onFieldSelect={this.handleFieldSelect}
                      />
                    </div>
                  );
                } else {
                  return (
                    <FormFieldWrapper
                      key={`card-container-${i}`}
                      card={card}
                      index={i}
                      editItem={this.editItem}
                      copyItem={this.copyItem}
                      copyToForm={this.copyToForm}
                      deleteItem={this.deleteItem}
                      moveCard={this.moveCard}
                      upItem={this.upItem}
                      downItem={this.downItem}
                      onFieldSelect={this.handleFieldSelect}
                    />
                  );
                }
              })}
            </div>
          </div>
        </CustomPaper>

        <CustomPaper
          style={{
            marginTop: '16px',
            wordWrap: 'break-word',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            launchSettingDialog();
          }}
        >
          {redirectToExternalUrl ? (
            <>
              <OpenInNew /> &nbsp; Redirect to external URL when submitted
              {redirectUrl && (
                <span style={{ marginLeft: '8px', color: 'var(--mui-palette-text-secondary)', fontSize: '0.9em' }}>
                  ({redirectUrl.length > 40 ? redirectUrl.substring(0, 40) + '...' : redirectUrl})
                </span>
              )}
            </>
          ) : linkedComponent ? (
            <>
              <DirectionsRounded /> &nbsp; Redirect to next page when submitted
            </>
          ) : (
            <>
              <PlaylistAddCheckRounded /> &nbsp; Display submission page when submitted
            </>
          )}
        </CustomPaper>

        <CopyToFormDialog
          open={this.state.copyToFormDialogOpen}
          onClose={this.handleCloseCopyToFormDialog}
          questionId={this.state.copyToFormQuestionId}
          currentFormId={this.props.formId}
        />
      </>
    );
  }
}

export default withStyles(styles)(Validation);
